import React from 'react'

const Heading = ({ title }) => {
    return (
        <h3 className='text-2xl font-semibold'>{title}</h3>
    )
}

export default Heading